/**
 * Values that carry no meaningful information in hazard scenario parameters.
 * Used by both filter resolution and grid axis resolution to exclude noise.
 */
export const UNINFORMATIVE_PARAM_VALUES = new Set<unknown>(['Not specified', '', null, undefined])

/**
 * Returns true if a scenario parameter value is meaningful —
 * i.e. not null, undefined, or an uninformative placeholder.
 */
export const isMeaningfulParamValue = (value: unknown): boolean =>
  !UNINFORMATIVE_PARAM_VALUES.has(value)
